export const locale = {
    lang: "ca",
    data: {
        login: {
            title: "Iniciar sesión en Admin",
            email: {
                label: "Email",
                validation: {
                    required: "Email es un campo obligatorio",
                    emailFormat: "Formato inválido",
                },
            },
            password: {
                label: "Contraseña",
                validation: {
                    required: "Contraseña es un campo obligatorio",
                },
            },
            staySignedId: "Permanecer conectado",
            forgotPassword: "¿Has olvidado tu contraseña ?",
            forgotPasswordTitle: "Recuperar contrasenya",
            enterEmailToReset: "Ingresa tu correo para restablecer contraseña",
            send: "Enviar",
            cancel: "Cancelar",
            backToLogin: "Tornar a l'inici de sessió",
            signInButton: "Ingresar",
            contentTitle: "Bienvenido al Sitio de Industrias JLC",
            contentMessage:
                "Sitio Web de Industrias JLC con más de 65 años ofreciéndote los mejores productos para la limpieza de tu hogar. Conoce nuestra historia, productos y tips.",
            passwordRecoveryConfirmation: {
                message: "La instrucción de recuperación de contraseña ha sido enviada a su correo electrónico.",
            },
            passwordRecoveryError: {
                message: "Error en la petición de recuperación de contraseña.",
            },
            passwordRecoveryCaptchaRequired: {
                message: "Completa la verificació abans d'enviar la sol·licitud.",
            },
            passwordRecoveryCaptchaError: {
                message: "No s'ha pogut validar la verificació. Torna-ho a provar.",
            },
            resetPassword: {
                title: "Restablir contrasenya",
                confirmPassword: "Confirmar contrasenya",
                submit: "Canviar contrasenya",
                success: "La contrasenya s'ha actualitzat correctament. Inicia sessió amb la nova contrasenya.",
                policy: "La contrasenya ha de tenir com a mínim {{minLength}} caràcters.",
                validation: {
                    minLength: "La contrasenya ha de tenir com a mínim {{minLength}} caràcters.",
                    confirmRequired: "Has de confirmar la contrasenya.",
                    match: "Les contrasenyes no coincideixen.",
                },
            },
            resetPasswordError: {
                generic: "No s'ha pogut restablir la contrasenya. Torna-ho a provar.",
                invalidToken: "L'enllaç de recuperació no és vàlid o ha caducat.",
            },
            signInError: {
                title: "Error al  ingresar",
                genericMessage: "Prueba otra vez más tarde",
                invalidMessage: "Usuario o contraseña no son validos",
            },
        },
    },
};
